mutation UpdateAudienceForEntityList($audience: AudienceUpdateInput!) {
    audienceUpdate(input: $audience) {
        audience {
            id
            name
            htmlUrl
            htmlUrlPath
            htmlUrlPathForList
            membershipStats {
                totalCount {
                    value
                    suffix
                    prefix
                    formatted
                }
            }
            createdTime
            isRecentlyCreated
            description
        }
    }
}
